import React, { useContext } from 'react';
import QRCode from 'react-qr-code';
import { EntitiesContext } from '../../App';

export default function InventoryPrint() {
  const entities = useContext(EntitiesContext);
  const lists = entities.state.get('list');
  const items = entities.state.get('inventory');

  const showListItem = item => {
    if (item) return lists.get(parseInt(item)).label;

    return '';
  }

  const data = () => {
    const rows = [...Array( Math.ceil(items.count() / 2) )];
    const productRows = rows.map((row, idx) => items.slice(idx * 2, idx * 2 + 2));

    const content = productRows.map((row, idx) => (
      <div className="columns" key={idx}>
        {row.valueSeq().map(i => <div key={i.id} className="column">
          <div className="columns">
            <div className="column is-narrow">
              <QRCode size={75} value={i.id.toString()} />
            </div>
            <div className="column">
              id: {i.id}<br/>
              Name: {i.name}<br/>
              Price: ${i.price}<br/>
              Condition: {showListItem(i.condition)}<br/>
              Category: {showListItem(i.category)}<br/>
              Clothing Type: {showListItem(i.clothing_type)}<br/>
              Size: {showListItem(i.size)}<br/>
              Boot Size: {showListItem(i.boot_size)}<br/>
              Length: {i.length}<br/>
              Skate Size: {i.skate_size}
            </div>
          </div>
        </div>)}
      </div>)
    );

    return <div>{content}</div>;
  }

  return <div className="mt-2">{ data() }</div>
}
